import React, { useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../Styles/Styles/dashboardstyle.css";

import rightImage from "../../Assets/img/test.png";
import Logo from "../../Assets/img/logo.png";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import axios from "axios";
import { security_key, BASE_URL } from "../../global";
import LinearProgress from "@mui/material/LinearProgress";

const Restpasswoed = () => {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const email = location.state?.email;
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const togglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  }


  const initialValues = {
    password: "",
    confirm_password: "",
  };

  const imgDimensions = {
    width: "520px",
    height: "520px",
  };

  const pStyle = {
    width: "70%",
    fontSize: "16px",
    fontWeight: "500",
  };

  const linkStyle = {
    fontSize: "16px",
    textDecoration: "none",
  };

  const iconStyle = {
    fontSize: "10px",
  };

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters.")
      .max(100, "Password must be at most 100 characters.")
      .matches(/[a-zA-Z]/, "Password must contain at least one letter.")
      .matches(/\d/, "Password must contain at least one number.")
      .matches(
        /[@$!%*?&#]/,
        "Password must contain at least one special character."
      )
      .required("Password is required."),

    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match.")
      .required("Confirm password is required."),
  });

  const { values, handleBlur, touched, handleChange, errors, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: async (formValues) => {
        toast.dismiss();
        setIsSubmitting(true);
        try {
          const response = await axios.post(`${BASE_URL}API/apicall`, {
            security_key,
            mode: "changePassword",
            user_email: email,
            ...formValues,
          });
          const output = response.data;
          if (output === 1) {
            toast.success("Password changed successfully", { autoClose: 3000 });
            setTimeout(() => navigate("/login"), 3000);
          } else {
            toast.error("Failed to change password. Please try again.", {
              autoClose: 3000,
            });
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          toast.error("An error occurred. Please contact support.", {
            autoClose: 3000,
          });
        } finally {
          setIsSubmitting(false);
        }
      },
    });

  return (
    <>
      <ToastContainer position="top-center" />
      <section className="bg-1 site-main">
        <div className="container vh-100 d-flex justify-content-center align-items-center">
          <div className="site-sub-main bg-white">
            <div className="field d-none d-lg-block bg-1 text-center">
              <div className="wrapper">
                <div className="sub-wrapp d-flex align-items-center justify-content-center mt-5">
                  <div className="text-box-right text-start p-4 ">
                    <h2 className="fw-bold fs-3">Update Password</h2>
                    <p className="mb-1">Reset your password</p>
                  </div>
                </div>
                <div className="sub-wrapp">
                  <img
                    src={rightImage}
                    className="img-fluid"
                    width={"529.09px"}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="field d-flex justify-content-center flex-column">
              <>
                <form
                  className="d-flex flex-column justify-content-center align-items-center"
                  onSubmit={handleSubmit}
                  ref={formRef}
                >
                  <h2 className="fw-semibold text-center fs-4 mb-15">
                    Reset your password
                  </h2>
                  <div className="input-field position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      id="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.password && touched.password && (
                      <div className="text-danger">{errors.password}</div>
                    )}
                    <label
                      className="position-absolute"
                      style={{
                        top: "0px",
                        left: "10px",
                        pointerEvents: "none",
                        transition: "0.3s",
                      }}
                    >
                      Password
                    </label>
                    <div
                      className="position-absolute"
                      style={{ bottom: "13px", right: "12px" }}
                    >
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="password-toggle"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }} // Optional: style for better UX
                        dangerouslySetInnerHTML={{
                          __html: showPassword
                            ? `<i class="fa-regular fa-eye-slash"></i>`
                            : `<i class="fa-regular fa-eye"></i>`,
                        }}
                      />
                    </div>
                  </div>
                  <div className="input-field mt-2 position-relative">
                    <input
                      type={showPassword2 ? "text" : "password"}
                      id="confirm_password"
                      value={values.confirm_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.confirm_password && touched.confirm_password && (
                      <div className="text-danger">
                        {errors.confirm_password}
                      </div>
                    )}
                    <label
                      className="position-absolute"
                      style={{
                        top: "0px",
                        left: "10px",
                        pointerEvents: "none",
                        transition: "0.3s",
                      }}
                    >
                      Confirm password
                    </label>
                    <div
                      className="position-absolute"
                      style={{ bottom: "13px", right: "12px" }}
                    >
                      <button
                        type="button"
                        onClick={togglePasswordVisibility2}
                        className="password-toggle"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }} // Optional: style for better UX
                        dangerouslySetInnerHTML={{
                          __html: showPassword2
                            ? `<i class="fa-regular fa-eye-slash"></i>`
                            : `<i class="fa-regular fa-eye"></i>`,
                        }}
                      />
                    </div>
                  </div>
                  <div className="btn-grp mt-3 w-100 d-flex align-items-center justify-content-center">
                    <button
                      type="submit"
                      className="btn btn-dark submit-btn fw-semibold"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Updating..." : "Update"}
                    </button>
                  </div>
                  {isSubmitting && <LinearProgress />}
                </form>
              </>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Restpasswoed;
